import React, { useEffect, useState, useRef } from 'react'
import CloseIcon from '@material-ui/icons/Close'
import { Button } from 'carbon-components-react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import { blindShuffle } from '../utils/SmartLabelUtils'

const MultipleChoiceAI = (props) => {
  const { answer, options, question } = props

  const [sortedChoiceValueArray, setSortedChoiceValueArray] = useState([])
  const [selectedItem, setSelectedItem] = useState('')
  const [isCorrect, setIsCorrect] = useState(false)

  useEffect(() => {
    setSortedChoiceValueArray(blindShuffle(options))
  }, [options])

  return (
    <div className='ai-comp-cont'>
      <div className='mcq-ques'>
        <p className='mcq-ques-lqbel'>{question}</p>
      </div>
      {sortedChoiceValueArray.length > 0 &&
        sortedChoiceValueArray.map((option) => {
          return (
            <div
              className={
                selectedItem === option
                  ? isCorrect
                    ? 'mcq-option slctd-crct'
                    : 'mcq-option slctd-wrong'
                  : 'mcq-option'
              }
              onClick={() => {
                setSelectedItem(option)
                if (answer[0] === option) {
                  setIsCorrect(true)
                } else {
                  setIsCorrect(false)
                }
              }}
            >
              <p className='mcq-ques-lqbel'>{option}</p>
            </div>
          )
        })}
    </div>
  )
}

export { MultipleChoiceAI }
